import { useEffect, useState } from 'react'

import { TeamMemberRole } from '@api'
import { useUnit } from 'effector-react'
import Countdown, { zeroPad } from 'react-countdown'
import { useNavigate } from 'react-router'

import SaleImage from '@/assets/images/sale_image.png'
import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import { LocalStorageKeys } from '@/consts/localStorage.ts'
import { $account } from '@/models/account.ts'

export const maxBlackFridayOfferTime = new Date(1701158400000)
const specialOfferKey = `${LocalStorageKeys.SPECIAL_OFFER}${maxBlackFridayOfferTime.getTime()}`

export const isBlackFridayOfferRunning = () => {
  return Date.now() < maxBlackFridayOfferTime.getTime()
}

export const SpecialOfferDialog = () => {
  const navigate = useNavigate()
  const account = useUnit($account)
  const [shown, setShown] = useState(
    localStorage.getItem(specialOfferKey) == null &&
      isBlackFridayOfferRunning(),
  )

  useEffect(() => {
    const listener = () => {
      setShown(true)
    }

    document.addEventListener('special-offer', listener)

    return () => {
      document.removeEventListener('special-offer', listener)
    }
  }, [])

  if (account?.memberRole !== TeamMemberRole.LEADER) {
    return
  }

  return (
    <Dialog
      show={shown}
      bigDialog={true}
      onClose={() => {
        setShown(false)
        localStorage.setItem(specialOfferKey, 'true')
      }}
    >
      <Dialog.Header>
        <img
          src={SaleImage}
          alt="sale icon"
          className="ml-auto mr-auto inline w-[30%]"
        />
        <Dialog.Title>
          <h1 className="mb-3 text-[25pt]">50% Off Cyber Monday Sale</h1>
        </Dialog.Title>
      </Dialog.Header>
      <Dialog.Description>
        <div className="text-title mt-2 text-center text-lg">
          Hurry, exclusive offer today - enjoy a 50% discount on all new
          licenses and upgrades!
          <br />
          <br />
          The discount will be applied automatically on all monthly purchases.
          <br />
          <br />
          <h3 className="mb-2">Time left until it ends:</h3>
          <Countdown
            date={maxBlackFridayOfferTime}
            renderer={({ days, hours, minutes, seconds }) => (
              <h1 className="text-2xl">
                {days > 0 ? `${zeroPad(days)} : ` : ''}
                {hours > 0 ? `${zeroPad(hours)} : ` : ''}
                {zeroPad(minutes)} : {zeroPad(seconds)}
              </h1>
            )}
          />
        </div>
      </Dialog.Description>
      <Dialog.Footer>
        <Button
          className="w-full"
          onClick={() => {
            navigate('/licenses')
            setShown(false)
          }}
        >
          Get Discount
        </Button>
      </Dialog.Footer>
    </Dialog>
  )
}
